import {useEffect, useState, useRef, useCallback} from '@wordpress/element';
import classnames from 'classnames';

export const FastlaneModal = (
    {
        i18n,
        open,
        onClose,
        fastlane,
        onTokenize,
        shippingData
    }) => {
    const [rendered, setRendered] = useState(false);
    const currentData = useRef({fastlane, shippingData});

    const onClick = useCallback(async (e) => {
        e.preventDefault();
        try {
            const {
                paymentComponent
            } = currentData.current;

            const response = await paymentComponent.getPaymentToken();

            // call onTokenize
            onTokenize(response);

            // close modal
            onClose(true);
            setRendered(false);
        } catch (error) {
            console.log('Error tokenizing payment method. ', error);
        }
    }, []);

    useEffect(() => {
        currentData.current = {
            ...currentData.current,
            fastlane,
            shippingData
        };
    }, [fastlane, shippingData]);

    useEffect(() => {
        if (open) {
            const {
                shippingData
            } = currentData.current;
            const {
                needsShipping,
                shippingAddress
            } = shippingData;
            const props = {
                ...(needsShipping && {
                    shippingAddress: {
                        firstName: shippingAddress.first_name || '',
                        lastName: shippingAddress.last_name || '',
                        streetAddress: shippingAddress.address_1 || '',
                        extendedAddress: shippingAddress.address_2 || '',
                        locality: shippingAddress.city || '',
                        region: shippingAddress.state || '',
                        postalCode: shippingAddress.postcode || '',
                        countryCodeAlpha2: shippingAddress.country || '',
                        phoneNumber: shippingAddress.phone || '',
                    }
                })
            }
            fastlane.FastlanePaymentComponent(props).then(async instance => {
                currentData.current.paymentComponent = instance;
                await instance.render('.wc-ppcp-fastlane-modal-body');
                document.body.classList.add('fastlane-modal-open');
                setTimeout(() => {
                    setRendered(true);
                }, 250);
            });
        } else {
            document.body.classList.remove('fastlane-modal-open');
        }

        return () => document.body.classList.remove('fastlane-modal-open');
    }, [open]);

    return (
        <div className={classnames('wc-ppcp-fastlane-overlay', {'active': rendered})}>
            <div className="wc-ppcp-fastlane-modal">
                <div className="wc-ppcp-fastlane-modal-body">

                </div>
                <div className="wc-ppcp-fastlane-modal-buttons">
                    <button
                        className="wc-ppcp-fastlane-tokenize"
                        onClick={onClick}>
                        {i18n.continue}
                    </button>
                    <a
                        className="wc-ppcp-fastlane-cancel"
                        onClick={() => {
                            setRendered(false);
                            onClose();
                        }}>
                        {i18n.cancel}
                    </a>
                </div>
            </div>
        </div>
    )
}